import { FC, useMemo } from 'react';

import CustomMultiSelect from '@/components/Filtering/CustomMultiSelect.tsx';

import { useRoleOptions } from '@/hooks/use-role-options.ts';
import { useResolvedRoleSelection } from '@/hooks/use-task-filter-selection.ts';
import useConfig from '@/hooks/useConfig.ts';

import { useFilterStore } from '@/stores/filterStore.ts';

const RoleSelect: FC = () => {
    const { location_key } = useConfig();
    const { roleOptions: roles } = useRoleOptions();
    const { all_options, values } = useResolvedRoleSelection();

    const display_text = useMemo(() => {
        if (values.length === 0) return 'Keine Rolle';
        if (values.length === all_options.length) return `Alle Rolle (${roles.length})`;
        return `Ausgewählte Rolle (${values.length})`;
    }, [values.length, all_options.length, roles.length]);

    const handleToggle = (id: string): void => {
        const new_selected = values.includes(id) ? values.filter((value) => value !== id) : [...values, id];

        useFilterStore.setState((state) => ({
            selected_roles: {
                ...state.selected_roles,
                [location_key]: new_selected,
            },
        }));
    };

    const handleSelectAll = (): void => {
        if (values.length === all_options.length) {
            useFilterStore.setState((state) => ({
                selected_roles: {
                    ...state.selected_roles,
                    [location_key]: [],
                },
            }));
        } else {
            useFilterStore.setState((state) => ({
                selected_roles: {
                    ...state.selected_roles,
                    [location_key]: all_options.map((option) => option.value),
                },
            }));
        }
    };

    return (
        <CustomMultiSelect
            label="Alle Rolle"
            displayText={display_text}
            options={all_options}
            selected={values}
            handleToggle={handleToggle}
            handleSelectAll={handleSelectAll}
        />
    );
};

export default RoleSelect;
